import React, { useContext, createContext } from "react";
import axios from "axios";
import { getUserToken } from "../shared/utils";

export const ApiContext = createContext();
export const useApi = () => useContext(ApiContext);
export const ApiProvider = ({ children }) => {
	const defaultToken = getUserToken();

	// simple request header
	const header = {
		Authorization: defaultToken,
		"Content-Type": "application/json"
	};

	// simple request service
	const requestApi = async (method, url, body = {}) => {
		return await axios({
			headers: header,
			method: method,
			url: url,
			data: body
		});
	};

	const values = {
		requestApi
	};

	return <ApiContext.Provider value={values}>{children}</ApiContext.Provider>;
};
